import React, { useEffect, useState } from "react";
import { CANDIDATE_LEVEL_ORDER } from "../../../constants/app";

interface Position {
  id: number;
  uuid: string;
  name: string;
  description: string;  
}

interface PositionListProps {
  positions: Position[];
  alternatePosition: string;
  // Whether to show all positions or just the first two
  fullVacancyName?: boolean
  removeLineBreaks?: boolean;
}

const VacancyPosition: React.FC<PositionListProps> = ({
  positions,
  alternatePosition,
  fullVacancyName = false,
  removeLineBreaks = false,
}) => {
  const [showAll, setShowAll] = useState(false);

  const handleToggle = () => {
    setShowAll((prev) => !prev);
  };

  useEffect(() => {
    setShowAll(fullVacancyName);
  }, [fullVacancyName]);

  if (positions?.length === 0) {
    return <div>{alternatePosition}</div>;
  }

  const sortedPositions = [...(positions ?? [])].sort(
    (a, b) =>
      (CANDIDATE_LEVEL_ORDER[a.name as keyof typeof CANDIDATE_LEVEL_ORDER] ?? 99) -
      (CANDIDATE_LEVEL_ORDER[b.name as keyof typeof CANDIDATE_LEVEL_ORDER] ?? 99)
  );

  const firstTwoNames = sortedPositions
    .slice(0, 2)
    .map((position) => position.name)
    .join(", ");
  const remainingCount = sortedPositions.length - 2;

  return (
    <span>
      {showAll ? (
        <span>
          {removeLineBreaks ? (
            sortedPositions.map((position) => position.name).join(", ")
          ) : (
            sortedPositions.map((position) => (
              <div key={position.id}>{position.name}</div>
            ))
          )}

          {
            !fullVacancyName && (
              <button onClick={handleToggle} className="btn btn-link">
                Show Less
              </button>
            )
          }
        </span>
      ) : (
        <div className="d-inline">
          {firstTwoNames}
          {remainingCount > 0 && (
            <>
              {" "}
              +{remainingCount}
              {" others"}
              {/* <button onClick={handleToggle} className="btn btn-link">
                Show All
              </button> */}
            </>
          )}
        </div>
      )}
    </span>
  );
};

export default VacancyPosition;
